"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var RootReducer_1 = require("../../app/RootReducer");
var HelpPublishCard_1 = require("../../img/model-results/HelpPublishCard");
var TestIds_1 = require("../../util/TestIds");
var Utils_1 = require("../../util/Utils");
var Index_1 = require("../base/Index");
var NavigationContext_1 = require("../base/NavigationContext");
var ModelResultKeyMetricTable_1 = require("./binomial/ModelResultKeyMetricTable");
var ModelResultPredictionDetail_1 = require("./common/ModelResultPredictionDetail");
var ModelResultPredictionExamination_1 = require("./common/ModelResultPredictionExamination");
var ModelResultStatisticInfo_1 = require("./regression/ModelResultStatisticInfo");
var PREDICTION_EXAMINATION_DETAIL_WIDTH = 250;
var ModelResultAdditionalMetrics = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), modelType = _a.type, modelMetrics = _a.modelMetrics;
    var refs = React.useContext(NavigationContext_1.NavigationContext);
    var setNavigationRef = function (node) {
        refs['MODEL_RESULT_ADDITIONAL_PERFORMANCE_METRICS'] = node;
    };
    if (!modelMetrics || !modelType) {
        return React.createElement(Index_1.Error, { message: Localize_1.Messages.chartErrorMessage(), testId: TestIds_1.MODEL_RESULT_CHART_ERROR_TEST_ID + 'additional-metrics' });
    }
    var renderBinomialModelContent = function () {
        return (React.createElement(Index_1.Card, null,
            React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.ModelResultAdditionalMetricsPerfMetrics() },
                React.createElement(ModelResultKeyMetricTable_1.default, null))));
    };
    var renderRegressionModelContent = function () {
        return (React.createElement(Index_1.Card, null,
            React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.ModelResultAdditionalMetricsErrorMetrics() },
                React.createElement(ModelResultStatisticInfo_1.default, null))));
    };
    var renderPredictionExamination = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Index_1.Card, { styles: { width: '80%' } },
                React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.ModelResultPredictionExamination() },
                    React.createElement(ModelResultPredictionExamination_1.ModelResultPredictionExamination, null))),
            React.createElement(Index_1.Card, null,
                React.createElement(Index_1.Card.Container, { header: "", width: PREDICTION_EXAMINATION_DETAIL_WIDTH },
                    React.createElement(ModelResultPredictionDetail_1.default, null)))));
    };
    return (React.createElement("div", { ref: setNavigationRef, "data-tb-test-id": TestIds_1.MODEL_RESULT_ADDITIONAL_PERFORMANCE_METRICS_TEST_ID },
        React.createElement(Index_1.Card.List, { icon: React.createElement(HelpPublishCard_1.HelpPublishCard, null), title: Localize_1.Messages.ModelResultAdditionalMetricsTitle(), description: Localize_1.Messages.ModelResultAdditionalMetricsSubtitle(), expand: true },
            (0, Utils_1.isBinomialModel)(modelType) && renderBinomialModelContent(),
            (0, Utils_1.isRegressionModel)(modelType) && renderRegressionModelContent(),
            renderPredictionExamination())));
};
exports.default = ModelResultAdditionalMetrics;
//# sourceMappingURL=ModelResultAdditionalMetrics.js.map